webpackJsonp([65310338191660],{

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/WWantsome_Logo_Light1_03.5bef9e43.png";

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _WWantsome_Logo_Light1_ = __webpack_require__(575);
	
	var _WWantsome_Logo_Light1_2 = _interopRequireDefault(_WWantsome_Logo_Light1_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommEventsEntry = function CommEventsEntry(props) {
		return _react2.default.createElement(
			'div',
			{ className: 'row' },
			_react2.default.createElement(
				'div',
				{ className: 'col-md-12 col-sm-12 wow fadeInUp' },
				_react2.default.createElement(
					'div',
					{ className: 'team-wrapper' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						props.showLeft ? _react2.default.createElement(
							'div',
							{ className: 'col-md-2' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: props.link },
								_react2.default.createElement('img', { src: props.image, className: 'img-responsive' })
							)
						) : null,
						_react2.default.createElement(
							'div',
							{ className: 'col-md-10' },
							_react2.default.createElement(
								'h5',
								null,
								props.date
							),
							_react2.default.createElement(
								'h4',
								null,
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: props.link },
									props.title
								)
							),
							_react2.default.createElement(
								'p',
								null,
								props.text
							),
							_react2.default.createElement(
								'p',
								null,
								'\xA0'
							)
						),
						!props.showLeft ? _react2.default.createElement(
							'div',
							{ className: 'col-md-2' },
							_react2.default.createElement('br', null),
							_react2.default.createElement('br', null),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: props.link },
								_react2.default.createElement('img', { src: props.image, className: 'img-responsive' })
							)
						) : null,
						_react2.default.createElement(
							'p',
							null,
							'\xA0'
						)
					)
				)
			)
		);
	};
	
	var events = [{
		date: "Saturday, 28 March, 08:30",
		title: "Working effectively with Web API Core 3.1",
		link: "/community-events/webapi-core-3-1/",
		text: "All you need to know about: API Setup, Performance tips, integrations, testing, templates",
		showLeft: true,
		image: _WWantsome_Logo_Light1_2.default
	}, {
		date: "Saturday, 28 March, 13:30",
		title: "Asynchronous and parallel programming concepts using C#",
		link: "/community-events/async-tpl-concepts/",
		text: "Real hands-on experience workshop about asynchronous and parallel programming concepts using C#",
		showLeft: true,
		image: _WWantsome_Logo_Light1_2.default
	}, {
		date: "Saturday, 28 March, 08:30",
		title: "ELK Stack for beginners",
		link: "/community-events/elk-stack-beginners/",
		text: "This workshop focuses on how to use the ELK stack to build an end-to-end system for monitoring and log aggregation.",
		showLeft: true,
		image: _WWantsome_Logo_Light1_2.default
	}, {
		date: "Saturday, 28 March, 13:30",
		title: "Infrastructure as Code for beginners",
		link: "/community-events/infrastructure-code-beginners/",
		text: "Terraform is powerful and one of the most used tools which allow to manage infrastructure as code in various cloud vendors.",
		showLeft: true,
		image: _WWantsome_Logo_Light1_2.default
	}];
	
	var communityEventsIndex = function communityEventsIndex() {
		return _react2.default.createElement(
			'section',
			{ id: 'community', className: 'parallax-section' },
			_react2.default.createElement(
				'div',
				{ className: 'container' },
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement('br', null),
				_react2.default.createElement(
					'div',
					{ className: 'row' },
					_react2.default.createElement(
						'div',
						{ className: 'col-md-offset-2 col-md-8 col-sm-offset-2 col-sm-8' },
						_react2.default.createElement(
							'div',
							{ className: 'header-title' },
							_react2.default.createElement(
								'h1',
								null,
								'Free community events'
							),
							_react2.default.createElement('hr', null),
							_react2.default.createElement(
								'p',
								null,
								'On Saturday, 28 March at International Hotel Iasi.',
								_react2.default.createElement('br', null),
								'The events are free, all you need to do is register until 24 March and then wait for our confirmation',
								_react2.default.createElement('br', null),
								_react2.default.createElement(
									'b',
									null,
									'*Hands-On experience, you need your laptop. ',
									_react2.default.createElement('br', null),
									'Registration & Confirmation is required'
								)
							)
						)
					)
				),
				events.map(function (event) {
					return _react2.default.createElement(CommEventsEntry, event);
				})
			)
		);
	};
	exports.default = communityEventsIndex;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-community-events-index-js-69886e7708471ba43e48.js